import React from "react";
import WaveText from "../WaveText";

export default function ProsConsGeneratorPanel({
  showProsConsGenerator, generatedProsCons, showAskMe, showTemplates,
  showQuizGenerator, showABCDGenerator, showOpenQuestionsGenerator,
  showWordDefinitionGenerator, showWordTranslationGenerator, showFillInTheGapsGenerator,
  showTrueFalseGenerator, showWarmUpDiscussionGenerator, showCreateDialogueGenerator,
  showEssentialVocabularyGenerator, showLeadInActivitiesGenerator, showFourOpinionsGenerator,
  showCommunicativeSituationsGenerator,
  prosConsInput, setProsConsInput, prosConsLevel, setProsConsLevel,
  prosConsPairs, setProsConsPairs, prosConsLoading,
  setShowProsConsGenerator, setGeneratedProsCons, setSelectedTemplate,
  handleProsConsGenerate, handleProsConsInsert,
}) {
  if (!((showProsConsGenerator || generatedProsCons) && !showAskMe && !showTemplates && !showQuizGenerator && !showABCDGenerator && !showOpenQuestionsGenerator && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showFillInTheGapsGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={() => { setShowProsConsGenerator(false); setProsConsInput(""); setGeneratedProsCons(null); setSelectedTemplate(null); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4 }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Pros and Cons</span>
      </div>
      <textarea
        value={prosConsInput}
        onChange={e => setProsConsInput(e.target.value)}
        placeholder="Enter a topic (e.g., Online Learning, Remote Work, Social Media)..."
        rows={3}
        style={{ fontSize: 15, padding: '12px', borderRadius: 8, border: '1.5px solid #cfcfff', background: '#f7fbff', resize: 'vertical', fontFamily: 'Inter, Segoe UI, Arial, sans-serif', width: '100%', boxSizing: 'border-box' }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <label style={{ fontSize: 14 }}>Level:</label>
        <select value={prosConsLevel} onChange={e => setProsConsLevel(e.target.value)} style={{ fontSize: 14, borderRadius: 6, border: '1.5px solid #cfcfff', padding: '4px 10px' }}>
          <option value="A1">A1</option>
          <option value="A2">A2</option>
          <option value="B1">B1</option>
          <option value="B2">B2</option>
          <option value="C1">C1</option>
          <option value="C2">C2</option>
        </select>
        <label style={{ fontSize: 14 }}>Pairs:</label>
        <select value={prosConsPairs} onChange={e => setProsConsPairs(Number(e.target.value))} style={{ fontSize: 14, borderRadius: 6, border: '1.5px solid #cfcfff', padding: '4px 10px' }}>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
          <option value={6}>6</option>
          <option value={7}>7</option>
          <option value={8}>8</option>
        </select>
        <button onClick={handleProsConsGenerate} className={prosConsLoading ? 'magic-generating-btn' : 'magic-btn'} style={{ fontSize: 15, padding: '8px 16px', borderRadius: 8, border: 'none', background: prosConsLoading ? undefined : '#8a2be2', color: '#fff', fontWeight: 600, cursor: prosConsLoading ? 'wait' : 'pointer' }} disabled={prosConsLoading}>
          {prosConsLoading ? <WaveText /> : 'Do the magic'}
        </button>
      </div>
      {generatedProsCons && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Pros and Cons Exercise
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedProsCons.pros.length} pros, {generatedProsCons.cons.length} cons ready (pairs: {prosConsPairs})
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleProsConsInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
